import {useEffect, useState} from "react";
import {AdminUsersDashboardContext} from "root/s360components/AdminUsersDashboardContext";
import {getEschoolsUrlForSchool, getSALinksForSchool} from "root/DataFunctions/HelperDataFns";
import {
    getActiveConcernReportsForSchoolPromise
} from "root/DataFunctions/ConcernReportDataFns";
import {getDataFromResponse} from "root/globals";
import {handleAjaxError} from "root/DataFunctions/BaseDataFns";

const AdminUsersDashboardProvider = ({children, school_id}) =>
{
    const [ data, setData ] = useState ( {isLoading: true, data: {} }) ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        let dataStructure = {
            sa_admin: {
                p_link: null, si_all_schools_link: null
            },
            active_concern_report: [],
            eschools_url: {
                url: null
            }
        };

        getEschoolsUrlForSchool(school_id).then((results1) =>
        {
            getActiveConcernReportsForSchoolPromise(school_id).then((results2) =>
            {
                getSALinksForSchool(school_id).then((results3) =>
                {
                    //getGovernorLinks(school_id).then(results4) =>
                    dataStructure.eschools_url = getDataFromResponse(results1)[0];
                    dataStructure.active_concern_report = getDataFromResponse(results2);
                    dataStructure.sa_admin = getDataFromResponse(results3);

                    setData({isLoading: false, data: dataStructure});
                })
            })
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
    }

    return (
        <AdminUsersDashboardContext.Provider
            value={{
                isLoading: data.isLoading,
                data: data.data
            }}
        >
            {children}
        </AdminUsersDashboardContext.Provider>
    )
}

export default AdminUsersDashboardProvider;